/* Relax Master — WebwinkelKeur reviews op de collectiepagina's.
   Reviews als horizontale RIJ: continu auto-scroll, stopt bij hover, handmatig
   scrolbaar/sleepbaar (muis/trackpad/touch) — net als de homepage.
   De sterrenfilter blijft werken: bij filteren wordt de rij opnieuw opgebouwd.
   Met credentials ([data-wwk-id]+[data-wwk-public-code]) worden score + reviews live opgehaald;
   zonder blijven de server-gerenderde voorbeeldreviews staan. */
(function () {
  'use strict';

  function fmtScore(n) {
    if (isNaN(n)) return null;
    return n.toFixed(1).replace('.', ',');
  }
  function summaryToDisplay(avg) { return (avg - 1) * 2 + 2; } // WWK 1-5 -> 2-10
  function ratingToStars(r) {
    var n = parseFloat(r);
    if (isNaN(n)) return 5;
    if (n > 5) n = n / 2;            // 0-10 schaal -> 1-5
    return Math.max(1, Math.min(5, Math.round(n)));
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  var STAR = '<svg width="12" height="12" viewBox="0 0 24 24" fill="#fff"><path d="m12 2 2.9 6.26L21.6 9.2l-4.8 4.5 1.2 6.5L12 17.1 6 20.2l1.2-6.5L2.4 9.2l6.7-.94z"/></svg>';

  function cardHTML(r) {
    var stars = '';
    for (var i = 0; i < 5; i++) {
      stars += '<span style="width:20px;height:20px;border-radius:4px;background:#2f7d5a;display:flex;align-items:center;justify-content:center;">' + STAR + '</span>';
    }
    return '<div data-rm-rev-card data-rating="' + r.stars + '" style="background:#fff;border:1px solid #ece7dd;border-radius:14px;padding:26px 28px;display:flex;flex-direction:column;">' +
      '<div style="display:flex;align-items:center;justify-content:space-between;gap:12px;">' +
        '<div style="display:flex;gap:3px;">' + stars + '</div>' +
        '<span style="font-size:12px;font-weight:300;color:#b0a892;">' + esc(r.date) + '</span>' +
      '</div>' +
      '<p style="margin:16px 0 0;font-size:14.5px;font-weight:400;line-height:1.6;color:#3f4a45;flex:1;">' + esc(r.quote) + '</p>' +
      '<div style="margin-top:20px;padding-top:16px;border-top:1px solid #f0ebe0;font-size:13px;font-weight:500;color:#2d4947;">' + esc(r.name) + '</div>' +
    '</div>';
  }

  /* Eenmalig: rij-layout + scrollbar verbergen + randen laten faden. Teller (data-rm-rev-count) verbergen — die tonen we niet meer. */
  function injectStyle() {
    if (document.getElementById('rm-rev-row-style')) return;
    var st = document.createElement('style');
    st.id = 'rm-rev-row-style';
    st.textContent =
      '[data-rm-rev-count]{display:none !important;}' +
      '[data-rm-rev-grid]{cursor:grab;scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;' +
        '-webkit-mask-image:linear-gradient(90deg,transparent,#000 4%,#000 96%,transparent);' +
        'mask-image:linear-gradient(90deg,transparent,#000 4%,#000 96%,transparent);}' +
      '[data-rm-rev-grid]::-webkit-scrollbar{display:none;}' +
      '[data-rm-rev-grid].is-dragging{cursor:grabbing;}' +
      '.rm-rev-track{display:flex;width:max-content;}' +
      '.rm-rev-group{display:flex;gap:24px;padding-right:24px;align-items:stretch;}' +
      '.rm-rev-track [data-rm-rev-card]{flex:0 0 340px !important;width:340px !important;}' +
      '@media (max-width:600px){.rm-rev-track [data-rm-rev-card]{flex:0 0 280px !important;width:280px !important;}}';
    document.head.appendChild(st);
  }

  function init() {
    var box = document.querySelector('[data-rm-reviews]');
    if (!box) return;
    var grid = box.querySelector('[data-rm-rev-grid]');
    if (!grid) return;
    var countEl = box.querySelector('[data-rm-rev-count]');
    var emptyEl = box.querySelector('[data-rm-rev-empty]');
    var filterBtns = Array.prototype.slice.call(box.querySelectorAll('[data-rm-rev-filter]'));
    var current = 'alle';

    injectStyle();

    /* Bronkaarten inlezen (server-fallback) — daarna evt. vervangen door live feed */
    var source = Array.prototype.slice.call(grid.querySelectorAll('[data-rm-rev-card]')).map(function (c) {
      return { rating: c.getAttribute('data-rating') || '5', html: c.outerHTML };
    });

    /* Grid -> horizontale scroller met een track erin (inline !important wint van sectie-CSS) */
    grid.style.setProperty('display', 'block', 'important');
    grid.style.setProperty('grid-template-columns', 'none', 'important');
    grid.style.setProperty('overflow-x', 'auto', 'important');
    grid.style.setProperty('overflow-y', 'hidden', 'important');
    grid.style.setProperty('gap', '0', 'important');
    grid.style.setProperty('margin', '0', 'important');
    grid.style.setProperty('scroll-snap-type', 'none', 'important');
    var track = document.createElement('div');
    track.className = 'rm-rev-track';
    grid.innerHTML = '';
    grid.appendChild(track);

    function filtered() {
      return current === 'alle' ? source : source.filter(function (c) { return c.rating === current; });
    }

    function styleFilters() {
      filterBtns.forEach(function (b) {
        var on = b.getAttribute('data-rm-rev-filter') === current;
        b.style.background = on ? '#2d4947' : '#ffffff';
        b.style.color = on ? '#ffffff' : '#5b6661';
        b.style.borderColor = on ? '#2d4947' : '#ddd6c6';
      });
    }

    function render() {
      var list = filtered();
      if (countEl) countEl.textContent = list.length + ' reviews gevonden';
      if (!list.length) {
        track.innerHTML = '';
        grid.style.setProperty('display', 'none', 'important');
        if (emptyEl) emptyEl.style.display = 'block';
        return;
      }
      if (emptyEl) emptyEl.style.display = 'none';
      grid.style.setProperty('display', 'block', 'important');
      var groupHTML = list.map(function (c) { return c.html; }).join('');
      // Twee identieke groepen => naadloze loop
      track.innerHTML =
        '<div class="rm-rev-group">' + groupHTML + '</div>' +
        '<div class="rm-rev-group" aria-hidden="true">' + groupHTML + '</div>';
      grid.scrollLeft = 0;
    }

    filterBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        current = b.getAttribute('data-rm-rev-filter');
        styleFilters();
        render();
      });
    });

    styleFilters();
    render();
    startMarquee(grid);

    /* ---- Live feed ---- */
    var id = box.getAttribute('data-wwk-id');
    var code = box.getAttribute('data-wwk-public-code');
    if (!id || !code) return; // geen credentials -> voorbeeldreviews blijven staan

    var base = 'https://dashboard.webwinkelkeur.nl/api/1.0/';
    var qs = 'id=' + encodeURIComponent(id) + '&public_code=' + encodeURIComponent(code);

    // Score
    fetch(base + 'ratings_summary.json?' + qs)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.status === 'success' && d.data && d.data.rating_average) {
          var disp = fmtScore(summaryToDisplay(parseFloat(d.data.rating_average)));
          if (disp) document.querySelectorAll('[data-rm-rev-score]').forEach(function (el) { el.textContent = disp; });
        }
      })
      .catch(function () {});

    // Losse reviews
    fetch(base + 'ratings.json?' + qs + '&limit=30')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var raw = (d && (d.ratings || d.data)) || [];
        if (!raw.length) return;
        var mapped = raw.map(function (x) {
          return {
            quote: x.testimonial || x.comment || x.review || '',
            name: x.name || x.author || x.customer || 'Geverifieerde koper',
            date: x.create || x.created || x.date || '',
            stars: ratingToStars(x.rating != null ? x.rating : x.score)
          };
        }).filter(function (x) { return x.quote && x.quote.length > 1; });
        if (!mapped.length) return;
        source = mapped.map(function (r) { return { rating: String(r.stars), html: cardHTML(r) }; });
        render();
      })
      .catch(function () {});
  }

  /* Marquee-controller: continu auto-scroll + pauze bij hover + handmatig scrollen/slepen */
  function startMarquee(scroller) {
    var SPEED = 0.5;            // px per frame ≈ 30px/s
    var paused = false;
    var dragging = false;
    var moved = false;
    var startX = 0;
    var startScroll = 0;
    var resumeTimer = null;

    function half() { return scroller.scrollWidth / 2; }
    function wrap() {
      var h = half();
      if (h <= 0) return;
      if (scroller.scrollLeft >= h) scroller.scrollLeft -= h;
      else if (scroller.scrollLeft < 0) scroller.scrollLeft += h;
    }
    function step() {
      if (!paused && !dragging) {
        scroller.scrollLeft += SPEED;
        wrap();
      }
      requestAnimationFrame(step);
    }
    function pauseFor(ms) {
      paused = true;
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () { paused = false; }, ms);
    }

    scroller.addEventListener('mouseenter', function () { paused = true; clearTimeout(resumeTimer); });
    scroller.addEventListener('mouseleave', function () { if (!dragging) paused = false; });

    scroller.addEventListener('wheel', function () { pauseFor(1500); }, { passive: true });
    scroller.addEventListener('touchstart', function () { paused = true; clearTimeout(resumeTimer); }, { passive: true });
    scroller.addEventListener('touchend', function () { pauseFor(1500); }, { passive: true });

    scroller.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return; // touch gebruikt native scroll
      dragging = true; moved = false; paused = true;
      startX = e.clientX; startScroll = scroller.scrollLeft;
      scroller.classList.add('is-dragging');
      try { scroller.setPointerCapture(e.pointerId); } catch (err) {}
    });
    scroller.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 3) moved = true;
      scroller.scrollLeft = startScroll - dx;
      wrap();
    });
    function endDrag() {
      if (!dragging) return;
      dragging = false;
      scroller.classList.remove('is-dragging');
      pauseFor(800);
    }
    scroller.addEventListener('pointerup', endDrag);
    scroller.addEventListener('pointercancel', endDrag);
    scroller.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    scroller.addEventListener('scroll', wrap, { passive: true });

    requestAnimationFrame(step);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
